export default "__VITE_ASSET__GDm8nCde__"